/**
 * This was copied from the Shopify Dawn theme.
 */

// General Selectors
const selectors = {
  customerAddresses: '[data-customer-addresses]',
  addressCountrySelect: '[data-address-country-select]',
  addressContainer: '[data-address]',
  toggleAddressButton: 'button[aria-expanded]',
  cancelAddressButton: 'button[type="reset"]',
  deleteAddressButton: 'button[data-confirm-message]',
};

const attributes = {
  expanded: 'aria-expanded',
  confirmMessage: 'data-confirm-message',
};

/**
 * Account Addresses
 * @class
 */
class AccountAddresses {
  public elements: {
    container: HTMLElement;
    addressContainer: HTMLElement;
    toggleButtons: HTMLElement[];
    cancelButtons: HTMLElement[];
    deleteButtons: HTMLElement[];
    countrySelects: HTMLElement[];
  } = {
    container: null,
    addressContainer: null,
    toggleButtons: null,
    cancelButtons: null,
    deleteButtons: null,
    countrySelects: null,
  };

  constructor(container: HTMLElement) {
    this.elements.container = container;
    this.defineElements();
    this.setupCountries();
    this.bindEvents();
  }

  /**
   * Define the required elements.
   */
  defineElements(): void {
    const { container } = this.elements;
    this.elements = {
      ...this.elements,
      addressContainer: container.querySelector(selectors.addressContainer),
      toggleButtons: Array.from(
        document.querySelectorAll(selectors.toggleAddressButton)
      ) as HTMLElement[],
      cancelButtons: Array.from(
        container.querySelectorAll(selectors.cancelAddressButton)
      ) as HTMLElement[],
      deleteButtons: Array.from(
        container.querySelectorAll(selectors.deleteAddressButton)
      ) as HTMLElement[],
      countrySelects: Array.from(
        container.querySelectorAll(selectors.addressCountrySelect)
      ) as HTMLElement[],
    };
  }

  /**
   * Bind the related event handlers.
   */
  bindEvents(): void {
    this.elements.toggleButtons.forEach((element) => {
      element.addEventListener('click', this.handleAddEditButtonClick);
    });
    this.elements.cancelButtons.forEach((element) => {
      element.addEventListener('click', this.handleCancelButtonClick);
    });
    this.elements.deleteButtons.forEach((element) => {
      element.addEventListener('click', this.handleDeleteButtonClick);
    });
  }

  /**
   * Toggle's the address form open.
   * @param target - The element being interacted with.
   */
  toggleExpanded(target: HTMLElement): void {
    target.setAttribute(
      attributes.expanded,
      (target.getAttribute(attributes.expanded) === 'false').toString()
    );
  }

  /**
   * Add / edit form handling.
   * @param {currentTarget} - The element being interacted with.
   */
  handleAddEditButtonClick = ({ currentTarget }: Event): void => {
    this.toggleExpanded(currentTarget as HTMLElement);
  };

  /**
   * Cancel form handling.
   * @param {currentTarget} - The element being interacted with.
   */
  handleCancelButtonClick = ({ currentTarget }: Event): void => {
    let targetElement = currentTarget as HTMLElement;
    this.toggleExpanded(
      targetElement
        .closest(selectors.addressContainer)
        .querySelector(`[${attributes.expanded}]`)
    );
  };

  /**
   * delete form handling.
   * @param {currentTarget} - The element being interacted with.
   */
  handleDeleteButtonClick = ({ currentTarget }: Event): void => {
    let targetElement = currentTarget as HTMLElement;
    if (confirm(targetElement.getAttribute(attributes.confirmMessage))) {
      // @ts-ignore
      Shopify.postLink(targetElement.dataset.target, {
        parameters: { _method: 'delete' },
      });
    }
  };

  /**
   * Configure the contries to show.
   */
  setupCountries(): void {
    // @ts-ignore
    if (Shopify && Shopify.CountryProvinceSelector) {
      // @ts-ignore
      new Shopify.CountryProvinceSelector(
        'AddressCountryNew',
        'AddressProvinceNew',
        {
          hideElement: 'AddressProvinceContainerNew',
        }
      );

      this.elements.countrySelects.forEach((select) => {
        const formId = select.dataset.formId;
        // @ts-ignore
        new Shopify.CountryProvinceSelector(
          `AddressCountry_${formId}`,
          `AddressProvince_${formId}`,
          {
            hideElement: `AddressProvinceContainer_${formId}`,
          }
        );
      });
    }
  }
}

/**
 * Initiate account address.
 */
export const accountAddressesInit = (): void => {
  const container: HTMLElement = document.querySelector(
    selectors.customerAddresses
  );
  if (container) {
    new AccountAddresses(container);
  }
};
